import { Box, Button } from '@mui/material';

import Grid from '@mui/material/Unstable_Grid2';
import { LessonType } from '../../../content/models/LessonVm';
import React from 'react';

interface SubmissionPanelLabel {
  complete: string;
  collapse: string;
  finaliseQuiz: string;
  collapseQuiz: string;
}
interface CompletionPanelProps {
  lessonType: LessonType;
  preview: boolean;
  complete: boolean;
  quizLocked: boolean;
  lessonCompleted: boolean;
  portfolioLocked: boolean;
  onComplete: () => void;
}

const CompletionPanel = (props: CompletionPanelProps) => {
  const submissionLabel: SubmissionPanelLabel = {
    complete: 'Complete Lesson',
    collapse: 'Collapse Lesson',
    finaliseQuiz: 'Finalise Quiz',
    collapseQuiz: 'Collapse Quiz'
  };

  function getButtonLabel() {
    switch (props.lessonType) {
      case 'lesson': //* Basic
        return (props.preview && !props.lessonCompleted) ||
          (!props.preview && !props.complete)
          ? submissionLabel.complete
          : submissionLabel.collapse;
      case 'quiz':
        return !props.quizLocked
          ? submissionLabel.finaliseQuiz
          : submissionLabel.collapseQuiz;
      case 'assessment':
        return submissionLabel.collapse;
    }
  }

  return (
    <Box p={2} style={{ backgroundColor: '#eee' }}>
      <Grid container alignItems="center" justifyContent="center">
        <Grid>
          <Button
            variant="contained"
            color="primary"
            disabled={
              props.portfolioLocked &&
              (getButtonLabel() === submissionLabel.complete ||
                getButtonLabel() === submissionLabel.finaliseQuiz)
            }
            onClick={props.onComplete}
          >
            {getButtonLabel()}
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default CompletionPanel;
